import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { site } from "@/config/site";
import { Reveal } from "@/components/Reveal";
import { trackEvent } from "@/lib/analytics";

export function CTA({ title = "Ready for a finish you'll love?", text }) {
  return (
    <section className="relative overflow-hidden bg-ink py-20 md:py-28" data-testid="cta-section">
      <div
        className="pointer-events-none absolute -top-40 right-0 h-[420px] w-[420px] rounded-full opacity-25 blur-3xl"
        style={{ background: "radial-gradient(circle, #F97316 0%, transparent 65%)" }}
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-ember">Free, no-pressure estimate</p>
          <h2 className="mt-4 max-w-2xl font-display text-3xl font-bold tracking-tight text-slate-50 sm:text-4xl lg:text-5xl">
            {title}
          </h2>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-300">
            {text ||
              `Tell us about your project and we'll follow up to talk it through. ${site.hoursShort} — serving Delta, Ladner, Tsawwassen and Surrey.`}
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/estimate"
              data-testid="cta-estimate-btn"
              onClick={() => trackEvent("cta_estimate_click")}
              className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full bg-ember px-7 py-3 text-sm font-semibold text-white shadow-lg shadow-orange-900/40 transition-[background-color,transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:bg-ember-dark hover:shadow-xl"
            >
              Get a Free Estimate <ArrowRight className="h-4 w-4" aria-hidden="true" />
            </Link>
            <a
              href={site.phoneHref}
              data-testid="cta-call-btn"
              onClick={() => trackEvent("phone_click", { location: "cta" })}
              className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-full border border-slate-600 px-7 py-3 text-sm font-semibold text-slate-100 transition-[border-color,background-color,transform] duration-300 hover:-translate-y-0.5 hover:border-ember hover:bg-white/5"
            >
              <Phone className="h-4 w-4" aria-hidden="true" /> Call {site.phone}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
